import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Children, cloneElement, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './ScreenAnimator.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var ScreenAnimator = function ScreenAnimator(_ref) {
  var activeScreenKey = _ref.activeScreenKey,
      children = _ref.children;

  var _useState = useState(activeScreenKey || null),
      _useState2 = _slicedToArray(_useState, 2),
      activeScreen = _useState2[0],
      setActiveScreen = _useState2[1];

  var _useState3 = useState(Children.count(children)),
      _useState4 = _slicedToArray(_useState3, 1),
      screenCount = _useState4[0];

  useEffect(function () {
    if (activeScreen !== activeScreenKey) {
      setActiveScreen(activeScreenKey);
    }
  }, [activeScreenKey]);

  var switchScreen = function switchScreen(key) {
    setActiveScreen(key);
  };

  var activeScreenIndex = 0;
  var childrenElms = Children.map(children, function (child, index) {
    if (child.props.screenKey === activeScreen) {
      activeScreenIndex = index;
    }

    return /*#__PURE__*/_jsx("div", {
      style: {
        width: 100 / screenCount + '%'
      },
      children: /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
        switchScreen: switchScreen
      }))
    });
  });
  return /*#__PURE__*/_jsx("div", {
    className: "ptr-screen-viewport",
    children: /*#__PURE__*/_jsx("div", {
      className: "ptr-screen-container",
      style: {
        width: 100 * screenCount + '%',
        left: -100 * activeScreenIndex + '%'
      },
      children: childrenElms
    })
  });
};

ScreenAnimator.propTypes = {
  activeScreenKey: PropTypes.string,
  children: PropTypes.node
};
export default ScreenAnimator;